// Shared GraphQL queries for the live-session gathering UI: Home feed,
// GatheringSession (live LiveKit room + STT + photos), and PostGathering
// (recap, connections, LinkedIn share).

export const UPCOMING_GATHERINGS_QUERY = /* GraphQL */ `
  query Upcoming {
    upcomingGatherings {
      id
      title
      description
      startsAt
      endsAt
      participantCount
      isSignedUp
    }
  }
`;

export const GATHERING_DETAIL_QUERY = /* GraphQL */ `
  query Gathering($id: ID!) {
    gathering(id: $id) {
      id
      title
      description
      startsAt
      endsAt
      participantCount
      isSignedUp
    }
  }
`;

// ─── RSVP ──────────────────────────────────────────────────────────────
//
// Both the Home feed and the GatheringDetail page reserve/cancel; their
// return shapes differ slightly. Both hit the same resolvers.

export const RESERVE_GATHERING_MUTATION = /* GraphQL */ `
  mutation Reserve($gatheringId: ID!) {
    reserveGathering(gatheringId: $gatheringId) {
      id
      isSignedUp
      participantCount
    }
  }
`;

export const CANCEL_RESERVATION_MUTATION = /* GraphQL */ `
  mutation Cancel($gatheringId: ID!) {
    cancelReservation(gatheringId: $gatheringId) {
      id
      isSignedUp
      participantCount
    }
  }
`;

// ─── Live session ─────────────────────────────────────────────────────

export const JOIN_GATHERING_ROOM_MUTATION = /* GraphQL */ `
  mutation Join($gatheringId: ID!) {
    joinGatheringRoom(gatheringId: $gatheringId) {
      livekitUrl
      token
      roomName
      endsAt
      gatheringTitle
    }
  }
`;

export const LEAVE_GATHERING_ROOM_MUTATION = /* GraphQL */ `
  mutation Leave($gatheringId: ID!) {
    leaveGatheringRoom(gatheringId: $gatheringId)
  }
`;

// ─── Post-gathering ───────────────────────────────────────────────────

export const POST_GATHERING_QUERY = /* GraphQL */ `
  query Recap($gatheringId: ID!) {
    gathering(id: $gatheringId) { id title }
    roommates(gatheringId: $gatheringId) { id name linkedinUrl pictureUrl alreadyConnected }
    recapFor(gatheringId: $gatheringId) {
      id summary keyTakeaways
      notableQuotes { speaker quote }
      booksMentioned conceptsMentioned linkedinDraft
    }
  }
`;

export const LINKEDIN_PREVIEW_QUERY = /* GraphQL */ `
  query Preview($gatheringId: ID!) {
    linkedinSharePreview(gatheringId: $gatheringId) {
      imageUrl
      suggestedText
      mentionables { userId name linkedinSub }
      hasLinkedInToken
    }
  }
`;

export const PUBLISH_LINKEDIN_MUTATION = /* GraphQL */ `
  mutation Publish($gatheringId: ID!, $commentary: String!, $mentionedUserIds: [ID!]!) {
    publishLinkedInShare(gatheringId: $gatheringId, commentary: $commentary, mentionedUserIds: $mentionedUserIds) {
      postUrn
      feedUrl
    }
  }
`;

export const ADD_CONNECTION_MUTATION = /* GraphQL */ `
  mutation($gatheringId: ID!, $otherUserId: ID!) {
    addConnection(gatheringId: $gatheringId, otherUserId: $otherUserId) { id }
  }
`;

export const GENERATE_RECAP_MUTATION = /* GraphQL */ `
  mutation($gatheringId: ID!) { generateRecap(gatheringId: $gatheringId) }
`;

// ─── Personal views ───────────────────────────────────────────────────
// MY_CONNECTIONS_QUERY now lives in ./queries.ts so mobile can import it
// without pulling in the live-session bundle.

export const MY_REMINDERS_QUERY = /* GraphQL */ `
  query Reminders {
    myReminders { id text dueOn completedAt gatheringTitle }
  }
`;

export const COMPLETE_REMINDER_MUTATION = /* GraphQL */ `
  mutation($id: ID!) { completeReminder(id: $id) { id completedAt } }
`;

export const UPCOMING_BANNER_QUERY = /* GraphQL */ `
  query UpcomingBanner {
    upcomingGatherings {
      id
      title
      kind
      startsAt
      status
      isSignedUp
    }
  }
`;
